import { render, staticRenderFns } from "./NewGroup.vue?vue&type=template&id=94aaf9a6&scoped=true"
import script from "./NewGroup.vue?vue&type=script&lang=js"
export * from "./NewGroup.vue?vue&type=script&lang=js"
import style0 from "./NewGroup.vue?vue&type=style&index=0&id=94aaf9a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94aaf9a6",
  null
  
)

export default component.exports